"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rules_1 = require("./rules");
var addresses_1 = require("./addresses");
var create = function (network) {
    var addresses = network === "mainnet" ? addresses_1.mainnet : addresses_1.testnet;
    var rules = (0, rules_1.createPylonRules)(addresses);
    var stakeLPRuleSet = {
        rule: rules.stakeLPRule,
        transform: function (fragment, matched) { return ({
            msgType: "pylon/stake-LP",
            canonicalMsg: ["Stake ".concat(matched[8].value).concat(matched[0].value)],
            payload: fragment,
        }); },
    };
    var unstakeLPRuleSet = {
        rule: rules.unstakeLPRule,
        transform: function (fragment, matched) { return ({
            msgType: "pylon/unstake-LP",
            canonicalMsg: ["Unstake ".concat(matched[8].value).concat(matched[4].value)],
            payload: fragment,
        }); },
    };
    var lpStakingRewardRuleSet = {
        rule: rules.lpStakingRewardRule,
        transform: function (fragment, matched) { return ({
            msgType: "pylon/LP-staking-reward",
            canonicalMsg: ["Claim Reward ".concat(matched[7].value).concat(matched[3].value)],
            payload: fragment,
        }); },
    };
    var govStakeRuleSet = {
        rule: rules.govStakeRule,
        transform: function (fragment, matched) { return ({
            msgType: "pylon/governance-stake",
            canonicalMsg: [
                "Stake ".concat(matched[4].value).concat(matched[0].value, " to ").concat(matched[5].value),
            ],
            payload: fragment,
        }); },
    };
    var govUnstakeRuleSet = {
        rule: rules.govUnstakeRule,
        transform: function (fragment, matched) { return ({
            msgType: "pylon/governance-unstake",
            canonicalMsg: [
                "Unstake ".concat(matched[3].value).concat(matched[4].value, " to ").concat(matched[0].value),
            ],
            payload: fragment,
        }); },
    };
    var airdropRuleSet = {
        rule: rules.airdropRule,
        transform: function (fragment, matched) { return ({
            msgType: "pylon/airdrop",
            canonicalMsg: ["Claim ".concat(matched[4].value).concat(matched[5].value)],
            payload: fragment,
        }); },
    };
    return [
        stakeLPRuleSet,
        unstakeLPRuleSet,
        lpStakingRewardRuleSet,
        govStakeRuleSet,
        govUnstakeRuleSet,
        airdropRuleSet,
    ];
};
exports.default = create;
//# sourceMappingURL=index.js.map